export const selectOptions = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
];

/**
 * getFormattedValue - utility function that maps frequency to the expected format of react-select. The default value coming from PRD is 2
 * @param {number} frequency - frequency of repeat time for tt911 sound settings
 */

export const getFormattedValue = frequency => {
  return (
    selectOptions.find(o => o.value == frequency) || { value: 2, label: 2 }
  );
};
